<template>
  <div></div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  props: {
    triggerHook: {
      type: [Number, String],
      default: 'onEnter'
    },
    offset: {
      type: [Number],
      default: 0
    },
    duration: {
      type: [Number, String],
      default: '100%'
    },
    durationType: {
      // only works for product content ;(
      // height depends on page: window / element: content
      type: String,
      default: 'page'
    }
  },
  components: {},
  computed: {},
  methods: {
    onEnter (event) {
      this.$emit('onEnter', event)
    },
    onLeave (event) {
      this.$emit('onLeave', event)
    },
    onEnd (event) {
      this.$emit('onEnd', event)
    },

    handleResize: throttle(function () {
      this.durationResize()
    }, 1000),
    durationResize: function () {
      this.scene.duration(this.$el.parentElement.offsetHeight + 'px')
    }
  },
  mounted () {
    this.scene = new this.$sm.Scene({
      triggerElement: this.$el
    })
    this.scene.on('enter', this.onEnter, event)
    this.scene.on('leave', this.onLeave, event)
    this.scene.on('end', this.onEnd, event)
    this.scene.triggerHook(this.triggerHook)
    this.scene.offset(this.offset)
    this.scene.duration(this.duration)
    // this.scene.addIndicators()
    this.$smController.addScene(this.scene)
    if (this.durationType === 'element') {
      this.scene.duration(this.$el.parentElement.offsetHeight + 'px')
      window.addEventListener('resize', this.handleResize)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    this.$smController.removeScene(this.scene)
    this.scene.off('enter', this.onEnter)
    this.scene.off('leave', this.onEnter)
    this.scene.off('end', this.onEnter)
    this.scene = this.scene.destroy(true)
  },
  watch: {
    offset: function (next) {
      this.scene.offset(next)
    },
    triggerHook: function (next) {
      this.scene.triggerHook(next)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/vue-scrollmagic/SMEvent.vue